/**
 * O envio de arquivo não pode carregar `Content-Type: application/json`.
 *
 * O axios 1.x não ignora esse cabeçalho quando o corpo é um `FormData`: ele
 * OBEDECE. Em `lib/defaults/index.js` está escrito
 * `hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data`, ou seja,
 * o formulário vira JSON e o arquivo simplesmente não sobe. Do outro lado o
 * Fastify vê um corpo que não é multipart e responde 422 "Envie o arquivo como
 * multipart/form-data" — mensagem correta sobre uma causa que está aqui.
 *
 * **O cabeçalho fixo continua na instância, e tirá-lo foi um erro medido.**
 * Sem ele, um POST *sem corpo* — `api.post('/atendimentos/1/link-prestador')`,
 * e há onze assim — sai com `application/x-www-form-urlencoded`, que é o
 * default do axios nesse caso. O Fastify não tem parser para esse tipo e
 * responde **415 Unsupported Media Type**. Medido contra a API:
 *
 *     POST sem content-type ............... 401 (passou, faltou token)
 *     POST application/json, corpo vazio .. 401 (passou)
 *     POST x-www-form-urlencoded .......... 415 (recusado antes do handler)
 *
 * Então a regra é: mantém-se `application/json` por padrão, e o cabeçalho é
 * removido SOMENTE quando o corpo é `FormData`. O interceptor roda antes do
 * `transformRequest`, então o axios enxerga a requisição sem tipo declarado e
 * deixa o navegador escrever o `multipart/form-data; boundary=...` — a parte
 * que só ele sabe montar.
 */
export function deixarMultipartPassar(config) {
  const corpo = config?.data;
  const ehFormData = typeof FormData !== 'undefined' && corpo instanceof FormData;
  if (!ehFormData || !config.headers) return config;

  if (typeof config.headers.delete === 'function') {
    config.headers.delete('Content-Type');
  } else {
    delete config.headers['Content-Type'];
    delete config.headers['content-type'];
  }
  return config;
}

export default deixarMultipartPassar;
